import { render } from "./2022-10-12-px em rem.md?vue&type=template&id=79750984"
const script = {}
script.render = render

export default script